'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nitroIcon = require('../nitro-icon');

var _nitroIcon2 = _interopRequireDefault(_nitroIcon);

var _NitroDrawerFooter = require('./NitroDrawerFooter');

var _NitroDrawerFooter2 = _interopRequireDefault(_NitroDrawerFooter);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//The noscroll package is causing the drawer to not render intermettiently due to wrong scrollbar size cal and position fixed prop as part
// of the package - Sriram
//import noScroll from 'no-scroll';

var NitroDrawer = function (_Component) {
  _inherits(NitroDrawer, _Component);

  function NitroDrawer(props) {
    _classCallCheck(this, NitroDrawer);

    var _this = _possibleConstructorReturn(this, (NitroDrawer.__proto__ || Object.getPrototypeOf(NitroDrawer)).call(this, props));

    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
    return _this;
  }

  _createClass(NitroDrawer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.isOpen) {
        //noScroll.on();
        document.body.style.overflow = 'hidden';
      }

      if (this.props.closeWithEscape) {
        document.addEventListener('keyup', this.handleKeyUp);
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (nextProps.isOpen !== this.props.isOpen) {
        if (nextProps.isOpen) {
          //noScroll.on();
          document.body.style.overflow = 'hidden';
        } else {
          //noScroll.off();
          document.body.style.overflow = 'auto';
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      //noScroll.off();
      // Safe to remove without checking props
      // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener#Notes
      document.removeEventListener('keyup', this.handleKeyUp);
      document.body.style.overflow = 'auto';
    }
  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(e) {
      if (this.props.isOpen && e.keyCode === 27) {
        // Close on escape click
        this.props.close();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpen = _props.isOpen,
          close = _props.close,
          children = _props.children,
          staticFooter = _props.staticFooter,
          iconVariant = _props.iconVariant,
          iconClass = _props.iconClass,
          noPadding = _props.noPadding,
          padding = _props.padding,
          variant = _props.variant,
          slideUp = _props.slideUp,
          height = _props.height,
          action = _props.action,
          actionLabel = _props.actionLabel,
          actionDisabled = _props.actionDisabled,
          actionLoading = _props.actionLoading,
          cancelAction = _props.cancelAction,
          cancelLabel = _props.cancelLabel,
          extraAction = _props.extraAction,
          extraLabel = _props.extraLabel,
          fullWidth = _props.fullWidth,
          width = _props.width,
          transition = _props.transition,
          actions = _props.actions,
          labelVariant = _props.labelVariant,
          closeIconSize = _props.closeIconSize,
          className = _props.className,
          actionFooter = _props.actionFooter;


      var iconColor = variant ? 'white' : 'base3';

      if (iconVariant) {
        iconColor = iconVariant;
      }

      var contentPadding = padding || '18px 16px';
      if (noPadding) {
        contentPadding = '0';
      }

      var actionSection = _react2.default.createElement(_NitroDrawerFooter2.default, {
        actions: actions,
        width: width,
        isOpen: isOpen,
        close: close,
        action: action,
        actionLabel: actionLabel,
        cancelAction: cancelAction,
        cancelLabel: cancelLabel,
        labelVariant: labelVariant
      });

      var closeButton = _react2.default.createElement(
        _styles.Close,
        { fixed: isOpen && fullWidth, onClick: close, type: 'button', variant: iconVariant || 'base3' },
        _react2.default.createElement(_nitroIcon2.default, { name: 'close', size: closeIconSize, clickable: true, variant: iconVariant })
      );

      var staticActionFooter = _react2.default.createElement(_NitroDrawerFooter2.default, { width: width, isOpen: isOpen, close: close, actionFooter: actionFooter });

      if (slideUp) {
        return _react2.default.createElement(
          'div',
          { className: className },
          _react2.default.createElement(
            _styles.BottomDrawer,
            { height: height, open: isOpen, variant: variant, transition: transition },
            _react2.default.createElement(
              _styles.DrawerContent,
              { staticFooter: staticFooter, padding: contentPadding },
              closeButton,
              children
            ),
            staticFooter && actionSection
          ),
          _react2.default.createElement(_styles.Background, { open: isOpen, onClick: close })
        );
      }

      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          _styles.RightDrawerContainer,
          {
            width: width,
            open: isOpen,
            variant: variant,
            fullWidth: fullWidth,
            transition: transition },
          _react2.default.createElement(
            _styles.DrawerContent,
            { staticFooter: staticFooter, padding: contentPadding, actionFooter: actionFooter },
            closeButton,
            children
          ),
          staticFooter && actionSection,
          actionFooter && staticActionFooter
        ),
        _react2.default.createElement(_styles.Background, { open: isOpen, onClick: close })
      );
    }
  }]);

  return NitroDrawer;
}(_react.Component);

NitroDrawer.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  close: _propTypes2.default.func.isRequired,
  staticFooter: _propTypes2.default.bool,
  actionFooter: _propTypes2.default.object,
  actions: _propTypes2.default.object,
  children: _propTypes2.default.node,
  iconVariant: _propTypes2.default.string,
  noPadding: _propTypes2.default.bool,
  padding: _propTypes2.default.string,
  variant: _propTypes2.default.string,
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  slideUp: _propTypes2.default.bool,
  fullWidth: _propTypes2.default.bool,
  transition: _propTypes2.default.bool,
  closeWithEscape: _propTypes2.default.bool,
  labelVariant: _propTypes2.default.string,
  closeIconSize: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.object]),
  className: _propTypes2.default.string
};

NitroDrawer.defaultProps = {
  actionLabel: 'Apply',
  cancelLabel: 'Cancel',
  closeWithEscape: true,
  extraLabel: 'Delete',
  slide: 'left',
  transition: true,
  width: 460,
  closeIconSize: '16'
};

exports.default = NitroDrawer;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-drawer/NitroDrawer.js
// module id = 2904
// module chunks = 4